import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  variant?: 'elevated' | 'outlined';
}

/**
 * Card component for grouping related content
 * Variants: elevated (shadow) or outlined (border)
 */
export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ children, variant = 'elevated', className, ...props }, ref) => {
    const baseClasses = 'rounded-2xl bg-white/90 backdrop-blur-sm p-6 shadow-[0_12px_40px_rgba(15,23,42,0.08)]';

    const variantClasses =
      variant === 'elevated'
        ? 'border border-slate-200/80'
        : 'border border-slate-300';

    const combinedClass = [baseClasses, variantClasses, className]
      .filter(Boolean)
      .join(' ');

    return (
      <div ref={ref} className={combinedClass} {...props}>
        {children}
      </div>
    );
  },
);

Card.displayName = 'Card';
